import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-edit-customer-tag-modal',
  templateUrl: './edit-customer-tag-modal.component.html',
  styleUrls: ['./edit-customer-tag-modal.component.css']
})
export class EditCustomerTagModalComponent {

  @Input() customerId: number;
  @Input() tagName: string;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public handleRemove() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .removeCustomerTag(this.customerId, this.tagName)
      .then(() => {
        const successText = 'Tag \'' + this.tagName + '\' removed successfully.';
        this.savedCallback({
          text: successText,
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove customer tags.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
